<template>
  <div style="min-height:100vh">
    <v-overlay absolute :opacity="0.75" v-if="loading">
      <div class="text-center">
        <v-progress-circular :size="100" indeterminate></v-progress-circular>
        <div class="caption mt-4">Loading</div>
      </div>
    </v-overlay>

    <v-dialog
      v-model="show_error_dialog"
      persistent
      :overlay-opacity="1"
      overlay-color="secondary"
      :max-width="400"
    >
      <v-card>
        <v-card-title class="primary white--text">
          Template unavailable
          <v-spacer></v-spacer>
          <v-icon dark>fa-exclamation-triangle</v-icon>
        </v-card-title>
        <v-card-text class="py-6">
          <div class="text-center pt-3">
            <h3 class>{{error_message}}</h3>
          </div>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn text to="/">Go Home</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <transition name="slide-x-reverse-transition">
        <v-container id="portal-template" v-if="template">
          <v-row justify="center">
            <v-col cols="11" sm="10" md="9" lg="8" xl="6">
              <v-container>
                <div>
                  <v-row justify="center" style="position:relative">
                    <v-col cols="12" sm="11" md="10" lg="9" xl="7" class="text-center">
                      <div>
                        <img
                          :title="template.settings.logo.name"
                          :src="template.settings.logo.url"
                          style="width:100%;max-width:375px;height:auto"
                          @click="$emit('logo-upload')"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <div id="template-info" v-if="template.title || template.description">
                  <v-row>
                    <v-col cols="12">
                      <h4>{{template.title}}</h4>
                      <p class="caption">{{template.description}}</p>
                    </v-col>
                  </v-row>
                </div>

                <div id="applicant-info">
                  <v-form autocomplete="off">
                    <v-row justify="center">
                      <v-col cols="12" class="py-2">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          name="name"
                          label="Name"
                          required
                          autocomplete="off"
                          v-model="applicant.name"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          required
                          name="email"
                          label="Email"
                          type="email"
                          inputmode="email"
                          v-model="applicant.email"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        class="py-2"
                        v-if="template.settings.applicants.require.phone"
                      >
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          required
                          name="phone"
                          label="Phone #"
                          type="tel"
                          inputmode="tel"
                          v-model="applicant.phone"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>

                <div id="template-sections">
                  <v-row>
                    <v-col cols="12" v-for="(section,s) in template.sections" :key="s">
                      <template-section :value="section"></template-section>
                    </v-col>
                  </v-row>
                </div>

                <div id="template-submit">
                  <v-row justify="space-around">
                    <v-col class="text-center" cols="12">
                      <v-btn x-large dark color="blue" @click="submit">Use this template</v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </transition>
    </div>
  </div>
</template>

<script>
import templateSection from "@/components/template/section";

export default {
  name: "Template",
  components: {
    templateSection
  },
  data() {
    return {
      loading: false,
      applicant: {
        name: "",
        email: "",
        phone: "",
        agree_terms: false
      },
      show_access_code_dialog: false,
      error_message: "",
      show_error_dialog: false, //Shows a popup saying the portal is unavailable. (user account is bad or portal isnt active)
      template: null
    };
  },
  computed: {},
  created() {
    this.load();
  },
  methods: {
    setPhone(ew) {
      this.applicant.phone = ew.e164;
    },
    agreeTerms() {
      this.show_terms = false;
    },
    async submit() {
      this.loading = true;
      try {
        this.$eventBus.$emit("new-portal", this.template);
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
    async load() {
      this.loading = true;
      this.access_code_invalid = false;

      try {
        let response = await this.$api(`/templates/${this.$route.params.id}`);
        this.template = response;
      } catch (ex) {
        this.error_message = ex.error;
        this.show_error_dialog = true;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>